import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useWealthSavingsBuildYourHeritageContent } from '../../../../hooks/useWealthSavingsBuildYourHeritageContent';
import './BuildYourHeritage.css';

const BuildYourHeritage = () => {
  const { content, isLoading } = useWealthSavingsBuildYourHeritageContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="build-your-heritage">
      <div className="build-your-heritage__inner">
        <Reveal className="build-your-heritage__content">
          <h2 className="build-your-heritage__title">{title}</h2>
          {text ? <p className="build-your-heritage__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="build-your-heritage__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default BuildYourHeritage;
